module.exports = __webpack_public_path__ + "static/media/mile2.f4f3c6a2.png";